export default __webpack_public_path__ + "static/demo_keberkesanan_sabun_champaca_8-9e214e0dee46a7634171399b4d29a3a4.mp4";